import type { Country } from "react-phone-number-input";
import { getCountries } from "react-phone-number-input";

import { useConfig } from "@jti/app-context/useConfig";

export const useAvailableCountries = (): Country[] => {
  const config = useConfig();
  const allCountries = getCountries();

  return config.internationalPhoneCountriesInDropdown.length
    ? (config.internationalPhoneCountriesInDropdown as Country[])
    : allCountries;
};
